import { useNavigate } from 'react-router-dom';
import { siteMeta, stats } from '../../../mocks/site';

export default function HomeHero() {
  const navigate = useNavigate();
  return (
    <section className="relative flex min-h-[620px] w-full items-center overflow-hidden md:min-h-[720px]">
      <img
        src="https://readdy.ai/api/search-image?query=dim%20nostalgic%20archive%20reading%20room%20with%20dusty%20bookshelves%20and%20scattered%20old%20photographs%20on%20a%20warm%20wooden%20desk%2C%20vintage%20newspaper%20clippings%2C%20soft%20amber%20lantern%20light%2C%20moody%20cinematic%20atmosphere%2C%20archival%20documentary%20photography%2C%20deep%20shadows%2C%20aged%20sepia%20and%20maroon%20tones%2C%20no%20text&width=1920&height=1080&seq=gossip-hero-x1&orientation=landscape"
        alt="故纸瓜档档案室场景背景图"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-background-100"></div>

      <div className="container-x relative z-10 w-full pb-16 pt-28 text-center md:pb-24 md:pt-32">
        <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-xs tracking-widest text-background-50/90 backdrop-blur-sm">
          <i className="ri-history-line"></i>八卦爆料 · 考古重读 · 当年真相
        </span>

        <h1 className="mx-auto mt-6 max-w-4xl font-display text-4xl font-black leading-tight text-background-50 md:text-6xl">
          {siteMeta.name}
          <span className="mt-2 block text-2xl font-bold text-accent-300 md:text-3xl">
            把尘封的旧瓜，重新翻开读一遍
          </span>
        </h1>

        <p className="mx-auto mt-6 max-w-2xl text-base leading-7 text-background-50/85 md:text-lg">
          这里是娱乐圈陈年旧瓜的档案室。那些当年的八卦爆料、历史旧闻、尘封往事，
          我们旧事重提，在时间线的起点重新解读当年真相，发现被忽略的细节与反转。
        </p>

        <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <button
            onClick={() => navigate('/column/kaogu-chongdu')}
            className="inline-flex cursor-pointer whitespace-nowrap items-center gap-2 rounded-md bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-search-eye-line"></i>进入考古重读
          </button>
          <a
            href="#chennian"
            className="inline-flex cursor-pointer whitespace-nowrap items-center gap-2 rounded-md border border-background-50/40 bg-background-50/10 px-7 py-3 text-sm font-medium text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20"
          >
            <i className="ri-arrow-down-line"></i>翻一翻陈年旧瓜
          </a>
        </div>

        <div className="mx-auto mt-12 grid max-w-3xl grid-cols-2 gap-4 sm:grid-cols-4">
          {stats.map((s) => (
            <div key={s.label} className="rounded-lg border border-background-50/20 bg-foreground-950/30 px-4 py-4 backdrop-blur-sm">
              <p className="font-display text-2xl font-black text-accent-300">{s.value}</p>
              <p className="mt-1 text-xs text-background-50/80">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}